module.exports = __webpack_public_path__ + "static/profile-c2806201a52dd5ad55bbcd60b15deb9a.png";